module.exports = "<div class=\"main-container\">\r\n  <nav class=\"header-container\">\r\n    <div class=\"unit-header-container\" *ngFor=\"let text of toolbarText; let i = 'index'\">\r\n  \r\n      <app-unitheader [id]=\"i\" [title]=\"text\" [id]=\"i\" (click)=\"onClick(i)\" [active]=\"selectedIndex === (i+2)\"></app-unitheader>\r\n\r\n    </div>\r\n  </nav> \r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/header-toolbar/header-toolbar.component.html
// module id = ../../../../../src/app/core/components/header-toolbar/header-toolbar.component.html
// module chunks = main